import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SearchLiteraturesComponent } from './search-literatures.component';
import { CmsConfig, I18nModule, provideConfig } from '@spartacus/core';
import { PageItemComponent } from './components/page-item/page-item.component';
import { AlertComponent } from '../../../../components/alert/alert.component';
import { LocalLoaderComponent } from '../../../../components/loader/local-loader/local-loader.component';
import { RouterModule } from '@angular/router';
import { CmsPageGuard, PageLayoutComponent, PaginationModule } from '@spartacus/storefront';

@NgModule({
  declarations: [SearchLiteraturesComponent],
  imports: [
    CommonModule,
    I18nModule,
    PageItemComponent,
    AlertComponent,
    LocalLoaderComponent,
    RouterModule.forChild([
      {
        path: 'search-literatures/:query',
        component: PageLayoutComponent,
        data: { pageLabel: 'search-literatures' },
        canActivate: [CmsPageGuard],
      },
    ]),
    PaginationModule,
  ],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        SearchLiteraturesResultList: {
          component: SearchLiteraturesComponent,
        },
      },
    }),
    provideConfig({
      routing: {
        routes: {
          searchLiterature: { paths: ['search-literatures/:query'] },
        },
      },
    }),
  ],
})
export class SearchLiteraturesModule {}
